
// euro symbol, comma, two digits
export function formatToPrice(priceString) {
    if (!priceString) return "";

    priceString = priceString.toString();

    // Replace comma with dot to handle input like "12,5"
    const normalized = priceString.replace(',', '.');

    // Convert to float
    const num = parseFloat(normalized);
    if (isNaN(num)) return "";

    // Format with 2 decimals, comma as separator, and euro sign
    return num.toFixed(2).replace('.', ',') + ' €';
}


/*
const formattedBasicPrice = Number(basicPrice).toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});
 */